/* Auto-advance any horizontal carousel marked data-auto-carousel="<track selector>".
   One card every data-auto-delay seconds, loops back to the start. Pauses only while a finger is dragging it.
   Matches the Pet owner favorites behavior. Waits for tracks that apps render after load. */
(function () {
  function init(root) {
    if (root.dataset.autoInit) return;
    var track = root.querySelector(root.dataset.autoCarousel);
    if (!track) {
      /* app-rendered tracks (Instafeed) appear after load: retry for ~15s */
      var tries = Number(root.dataset.autoTries || 0);
      if (tries < 30) {
        root.dataset.autoTries = tries + 1;
        setTimeout(function () { init(root); }, 500);
      }
      return;
    }
    root.dataset.autoInit = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var delay = (parseFloat(root.dataset.autoDelay) || 2) * 1000;
    var paused = false;
    var timer = null;

    /* where the track must sit for an item to rest on its snap point, clamped to the scroll range */
    function restFor(item) {
      var cs = getComputedStyle(track);
      var tr = track.getBoundingClientRect();
      var r = item.getBoundingClientRect();
      var padL = parseFloat(cs.scrollPaddingLeft) || 0;
      var padR = parseFloat(cs.scrollPaddingRight) || 0;
      var align = getComputedStyle(item).scrollSnapAlign;
      var delta;
      if (align.indexOf('center') > -1) {
        delta = (r.left + r.right) / 2 - (tr.left + padL + (tr.width - padL - padR) / 2);
      } else if (align.indexOf('end') > -1) {
        delta = r.right - (tr.right - padR);
      } else {
        delta = r.left - (tr.left + padL);
      }
      var max = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(max, Math.round(track.scrollLeft + delta)));
    }
    function next() {
      if (paused || document.hidden) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max < 4) return;
      if (track.scrollLeft >= max - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      var items = Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
      for (var i = 0; i < items.length; i++) {
        var left = restFor(items[i]);
        if (left > track.scrollLeft + 4) {
          track.scrollTo({ left: left, behavior: 'smooth' });
          return;
        }
      }
      track.scrollTo({ left: max, behavior: 'smooth' });
    }
    function start() {
      clearInterval(timer);
      timer = setInterval(next, delay);
    }

    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; start(); }, { passive: true });
    root.addEventListener('click', function (e) { if (e.target.closest('button')) start(); });
    start();
  }
  function all() { document.querySelectorAll('[data-auto-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
